import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getCPFContributionRateList = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetCPFContributionRates}?CompanyCode=${companyCode}`
  );

  return data;
};

const getCPFContributionRateById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CPFContributionRateAPI}??isAll=false&code=${code}`
  );
  return data;
};

const insertCPFContributionRate = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CPFContributionRateAPI,
    input
  );
  return data;
};

const updateCPFContributionRate = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.CPFContributionRateAPI,
    input
  );
  return data;
};

export const useCPFContributionRateQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetCPFContributionRates],
    queryFn: () => getCPFContributionRateList(companyCode),
    refetchOnWindowFocus: false,
  });
};

export const useGetCPFContributionRateByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFContributionRateAPI],
    queryFn: () => getCPFContributionRateById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertCPFContributionRateMutation = () => {
  return useMutation({
    mutationFn: insertCPFContributionRate,
  });
};

export const useUpdateCPFContributionRateMutation = () => {
  return useMutation({
    mutationFn: updateCPFContributionRate,
  });
};
